import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ISource } from '@user/store/sources'

type Props = {
  name: string
}

export function useHandlers(props: Props) {
  const { name } = props
  const { setFieldValue } = useFormikContext<IAddOpportunityFormModel>()

  const handelChange = useCallback((value: ISource | null) => {
    setFieldValue(name, value?.id ?? '')
    setFieldValue('leadSource', value?.name ?? '')
  }, [])
  return {
    handelChange,
  }
}
